import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import BrandLogo from './BrandLogo';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
    } catch (err: any) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-shell">
      <div data-testid="login-form" className="admin-login-card">
        <div className="admin-login-heading">
          <BrandLogo />
          <p className="admin-login-eyebrow">Operations</p>
          <h2>Admin sign in</h2>
          <p>Use an authorized ImgAff operations account.</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="admin-field">
            <label className="admin-label" htmlFor="email">Email address</label>
            <input
              id="email"
              data-testid="email-input"
              className="admin-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="you@imgaff.com"
            />
          </div>

          <div className="admin-field">
            <label className="admin-label" htmlFor="password">Password</label>
            <input
              id="password"
              data-testid="password-input"
              className="admin-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
            />
          </div>

          {error && (
            <div data-testid="error-message" role="alert" className="admin-error">
              <span>{error}</span>
            </div>
          )}

          <button
            data-testid="login-button"
            type="submit"
            disabled={loading}
            className="admin-btn admin-login-submit"
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

      </div>
    </div>
  );
};

export default Login;
